import { render, staticRenderFns } from "./BankStatements.vue?vue&type=template&id=2ab2fa1e&"
import script from "./BankStatements.vue?vue&type=script&lang=js&"
export * from "./BankStatements.vue?vue&type=script&lang=js&"
import style0 from "./BankStatements.vue?vue&type=style&index=0&id=2ab2fa1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports